import { useEffect } from "react";

/**
 * ── 변경사항 (ECHO 톤) ──
 * 1. 화면 어디에도 없던 보라색(#9C2DF0) 박스 → 민트 톤으로 교체
 * 2. "선택 없이 전체가 자동 출제되는 유형"임을 문장으로 명시
 * 3. selectedTypes 자동 설정과 문항 수 계산 로직은 기존 그대로
 */
const GrammarSelectionPage = ({
  worksheet,
  selectedTypes,
  setSelectedTypes,
}) => {
  // Grammar는 단일 섹션으로 처리 - 선택 없이 자동으로 설정
  useEffect(() => {
    if (setSelectedTypes !== undefined) {
      setSelectedTypes([{ key: "grammar", value: "어법테스트" }]);
    }
  }, [setSelectedTypes]);

  // 문제 수 계산
  const documents = worksheet.data?.documents || [];
  const totalQuestions = documents.reduce(
    (sum, doc) =>
      sum + (doc.data?.filter((q) => q.is_valid !== false)?.length || 0),
    0
  );

  return (
    <div style={{ padding: "22px" }}>
      <div className="ws-modal-title">어법 테스트 출제</div>
      <p className="ws-modal-sub" style={{ marginBottom: "16px" }}>
        이 학습지의 어법 문항 전체가 자동으로 출제됩니다.
      </p>

      <div
        style={{
          border: "1.5px solid #00D9C0",
          backgroundColor: "#F2FDFB",
          borderRadius: "13px",
          padding: "14px 17px",
        }}
      >
        <div
          style={{
            fontSize: "0.72rem",
            fontWeight: 800,
            letterSpacing: "0.05em",
            color: "#00A396",
          }}
        >
          출제 문항
        </div>
        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: 800,
            color: "#0E141B",
            marginTop: "2px",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          총 {totalQuestions}문제
        </div>
      </div>

      <div className="ws-hint" style={{ marginTop: "10px" }}>
        문항 선택이나 세트 설정 없이 <b>전체가 한 번에 출제</b>되는
        유형입니다.
      </div>
    </div>
  );
};

export default GrammarSelectionPage;
